import {
  AICG_SHOW_INIT,
  AICG_SHOW_DILOG,
  AICG_GET_QUESTION,
  AICG_GET_REPLYS,
  AICG_ADD_ZAN_DAO,
  AICG_REPLYS_ADD_REPLY,
  AICG_CLEAR_LIST,
  AICG_ADD_DOWNLOAD,
  AICG_REPLY_COMMAND_END,
  AICG_REPLY_WRITING_END,
  AICG_REPLY_WRITING_STOP,
  AICG_REPLY_IS_BUSING,
  AICG_SHOW_MESSAGE,
  AICG_SAVE_PREV_CONTEXT,
} from '../constants/aigc';

// 展示ai聊天框的入口
export const aigcShowInit = data => ({
  type: AICG_SHOW_INIT,
  data,
});

// 展示ai聊天框
export const aigcShowDialog = data => ({
  type: AICG_SHOW_DILOG,
  data,
});

// 获得回答的相关问题
export const aigcGetQuestion = data => ({
  type: AICG_GET_QUESTION,
  data,
});

// 发送消息获得回答结果
export const aigcGetReplys = data => ({
  type: AICG_GET_REPLYS,
  data,
});

// 当前replys的点赞或者倒
export const aigcReplysZanDao = data => ({
  type: AICG_ADD_ZAN_DAO,
  data,
});

// 向replyList添加数据
export const aigcReplyListAddReply = data => ({
  type: AICG_REPLYS_ADD_REPLY,
  data,
});
// 清除对话
export const aigcClearList = data => ({
  type: AICG_CLEAR_LIST,
  data,
});

// 点击按钮添加下载任务, 后的处理
export const aigcAddDownload = data => ({
  type: AICG_ADD_DOWNLOAD,
  data,
});

// 通知处理回复中的action完成, 后的处理
export const aigcReplyCommandEnd = data => ({
  type: AICG_REPLY_COMMAND_END,
  data,
});

// 当前replys打字效果结束, 后的处理
export const aigcReplysWritingEnd = data => ({
  type: AICG_REPLY_WRITING_END,
  data,
});

// 通知处理点击打字暂停回答
export const aigcReplyWritingStop = data => ({
  type: AICG_REPLY_WRITING_STOP,
  data,
});

// 通知处理点击打字暂停回答
export const aigcReplyIsBusing = data => ({
  type: AICG_REPLY_IS_BUSING,
  data,
});

// 通知ai消息弹窗是否弹出
export const aigcShowMessage = data => ({
  type: AICG_SHOW_MESSAGE,
  data,
});

// 通知ai消息点击了切换左右, 用于存储下一次消息的context
export const aigcSaveContext = data => ({
  type: AICG_SAVE_PREV_CONTEXT,
  data,
});
